import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';


import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';



const SoftwareDevelopment = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    const targetElement = document.getElementById(id);
    window.scrollTo({
      top: targetElement.offsetTop - 60, // Adjust this value to add space above the section
      behavior: 'smooth',
    });
  };

  return (
    <div>
      <section className="banner">
  <div className="banner-overlay"></div>
  <div className="banner-content">
    <h6 className="banner-subtitle">Services / Software Development</h6>
    <hr />
    <h1 className="banner-title">
      Empower Growth with <br /> Custom Software Development Solutions
    </h1>
    <button className="banner-button mt-3">
  <Link to="/contact" className="text-decoration-none text-white">
    Let’s talk <span className="arrow">→</span>
  </Link>
</button>
  </div>
  <img
    src="./assets/img/2005.png"
    alt="Banner Background"
    className="banner-image"
  />
</section>


      <section id="about_pg" className="p_3">
  <div className="container-xl">
    <div className="row about_pg1">
      <div className="col-md-6">
        <div className="about_pg1l mt-5">
          <h6 className="col_yell">Software Development</h6>
          <h2 className="mt-3 mb-3">Custom Software Solutions for a Digital Tomorrow</h2>
          <p>
            At <strong>Datafluent Analytics</strong>, we specialize in crafting custom software solutions 
            designed to streamline processes, enhance productivity, and drive innovation. Whether you're 
            scaling a startup or transforming an enterprise, our expert team delivers robust and scalable 
            applications tailored to your unique needs.
          </p>
        </div>
      </div>

      <div className="col-md-6">
        <div className="about_pg1r">
          <div className="grid clearfix">
            <figure className="effect-jazz mb-0">
              <a href="#">
                <img
                  src="./assets/img/2005.png"
                  className="w-100"
                  alt="Empowering Decisions"
                />
              </a>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>





<section id="software-development-services" class="py-5 bg-light text-dark">
    <div class="container">
        <h2 class="text-center">Our Services</h2>
        <p class="text-center mb-5">Providing innovative software solutions to help businesses grow and succeed.</p>
        <div class="row">


            <div class="col-md-4 mb-4">
                <div class="p-3 border rounded bg-white card-hover d-flex align-items-start shadow">
                    <i class="fa fa-cogs fa-3x text-primary me-3"></i>
                    <div>
                        <h6 class="mb-3 card-title">Custom Software Development</h6>
                        <p>We create custom software solutions tailored to meet your specific business requirements, optimizing workflows and enhancing efficiency.</p>
                    </div>
                </div>
            </div>

            
            <div class="col-md-4 mb-4">
                <div class="p-3 border rounded bg-white card-hover d-flex align-items-start shadow">
                    <i class="fa fa-laptop-code fa-3x text-primary me-3"></i>
                    <div>
                        <h6 class="mb-3 card-title">Web Application Development</h6>
                        <p>Our team builds responsive and scalable web applications designed to provide seamless user experiences across devices.</p>
                    </div>
                </div>
            </div>

            
           

           
            <div class="col-md-4 mb-4">
                <div class="p-3 border rounded bg-white card-hover d-flex align-items-start shadow">
                    <i class="fa fa-building fa-3x text-primary me-3"></i>
                    <div>
                        <h6 class="mb-3 card-title">Enterprise Software Solutions</h6>
                        <p>We provide enterprise-grade solutions that help businesses streamline operations, improve productivity, and achieve scalability.</p>
                    </div>
                </div>
            </div>

            
            <div class="col-md-4 mb-4">
                <div class="p-3 border rounded bg-white card-hover d-flex align-items-start shadow">
                    <i class="fa fa-tools fa-3x text-primary me-3"></i>
                    <div>
                        <h6 class="mb-3 card-title">Software Maintenance & Support</h6>
                        <p>Our services ensure that your software systems remain up-to-date, secure, and running smoothly with ongoing maintenance and support.</p>
                    </div>
                </div>
            </div>

            
           

             <div class="col-md-4 mb-4">
                <div class="p-3 border rounded bg-white card-hover d-flex align-items-start shadow">
                    <i class="fa fa-cloud fa-3x text-primary me-3"></i>
                    <div>
                        <h6 class="mb-3 card-title">Cloud Solutions & Architecture</h6>
                        <p>We design and implement cloud-based solutions, ensuring scalable, secure, and cost-efficient architectures for your business needs.</p>
                    </div>
                </div>
            </div>

            
            <div class="col-md-4 mb-4">
                <div class="p-3 border rounded bg-white card-hover d-flex align-items-start shadow">
                    <i class="fa fa-cloud-upload-alt fa-3x text-primary me-3"></i>
                    <div>
                        <h6 class="mb-3 card-title">SaaS-based Software Development</h6>
                        <p>We build and deploy scalable SaaS-based solutions that allow businesses to manage resources efficiently through the cloud.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<hr />

<section id="serv_h" className="p_3">
  <div className="container-fluid" style={{ padding: 40 }}>
    <div className="row serv_h1 mb-4 text-center">
      <div className="col-md-12">
        <div className="serv_h1l">
          <h3>Our Technology</h3>
          <p className="mb-0">Technologies and tools we specialize in</p>
        </div>
      </div>
    </div>

    <div className="my-swiper-container">
      <Swiper
        modules={[]}
        spaceBetween={16}
        loop={true}
        
        breakpoints={{
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        }}
      >
        {/* React.js */}
        <SwiperSlide>
          <img
            src="./assets/img/react-logo.svg"
            alt="React.js"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* python */}
        <SwiperSlide>
          <img
            src="https://www.python.org/static/community_logos/python-logo.png"
            alt="python"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>


        {/* Vue.js */}
        <SwiperSlide>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg"
            alt="Vue.js"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* Angular */}
        <SwiperSlide>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg"
            alt="Angular"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* Node.js */}
        <SwiperSlide>
          <img
            src="https://www.svgrepo.com/show/303360/nodejs-logo.svg"
            alt="Node.js"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* Laravel */}
        <SwiperSlide>
          <img
            src="https://cdn.rswebsols.com/wp-content/uploads/2022/09/Laravel-PHP-framework-logo-920x341.png?strip=all&lossy=1&ssl=1"
            alt="Laravel"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* Django */}
        <SwiperSlide>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/75/Django_logo.svg"
            alt="Django"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* PostgreSQL */}
        <SwiperSlide>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Postgresql_elephant.svg/810px-Postgresql_elephant.svg.png"
            alt="PostgreSQL"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* MySQL */}
        <SwiperSlide>
          <img
            src="https://d1.awsstatic.com/asset-repository/products/amazon-rds/1024px-MySQL.ff87215b43fd7292af172e2a5d9b844217262571.png"
            alt="MySQL"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        
        {/* Docker */}
        <SwiperSlide>
          <img
            src="https://www.docker.com/wp-content/uploads/2023/08/logo-guide-logos-1.svg"
            alt="Docker"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* Kubernetes */}
        <SwiperSlide>
          <img
            src="https://1000logos.net/wp-content/uploads/2022/07/Kubernetes-Logo-768x432.png"
            alt="Kubernetes"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

      </Swiper>

      <div className="my-swiper-button-prev"></div>
      <div className="my-swiper-button-next"></div>
    </div>
  </div>
</section>


  <hr />
  



  <section class="bg-light">
  <div class="container-fluid" style={{ padding: 40 }}>
    <div className="row serv_h1 mb-4">
      <div className="col-md-9">
        <div className="serv_h1l">
          <h3>Services We're Offering</h3>
          <p className="mb-0">Custom software solutions to drive business growth</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-university me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Banking</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-broadcast-tower me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Media, and Information Services</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-graduation-cap me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Education</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-hospital me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Healthcare</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-shield-alt me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Insurance</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-industry me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Manufacturing</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-shopping-cart me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Retail</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-chart-line me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Capital Markets</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-box me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Consumer Goods and Distribution</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-laptop-code me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">High Tech</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-users me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Public Services</a>
      </div>
      <div class="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
        <i class="fas fa-plane me-3 fs-4 text-black"></i>
        <a href="#" class="text-decoration-none text-dark fs-5">Travel and Logistics</a>
      </div>
    </div>
  </div>
</section>





<section id="serv_h" className="p_3">
  <div className="container-fluid" style={{ padding: 40 }}>
    <div className="row serv_h1 mb-4 text-center">
      <div className="col-md-12">
        <div className="serv_h1l">
          <h3>We Worked With</h3>
          <p className="mb-0">Trusted by leading innovators worldwide.</p>
        </div>
      </div>
    </div>

    <div className="my-swiper-container">
      <Swiper
        modules={[]}
        spaceBetween={16}
        loop={true}
        
        breakpoints={{
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        }}
      >
       
         {/* React.js */}
        <SwiperSlide>
          <img
            src="./assets/img/Dhaka_bank_logo.png"
            alt="React.js"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        {/* python */}
        <SwiperSlide>
          <img
            src="./assets/img/upay.png"
            alt="upay"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src="./assets/img/Dhaka-Shishu-Hospital-logo.jpg"
            alt="Client Logo 4"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>


        <SwiperSlide>
          <img
            src="./assets/img/banglalink.png"
            alt="Client Logo 6"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src="https://www.jobplant.com.au/images/job-plant_color.png"
            alt="Client Logo 6"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src="./assets/img/hive4work.png"
            alt="Client Logo 6"
            style={{
              width: "120px",
              height: "80px",
              objectFit: "contain",
              margin: "auto",
            }}
          />
        </SwiperSlide>

        

      </Swiper>

      <div className="my-swiper-button-prev"></div>
      <div className="my-swiper-button-next"></div>
    </div>
  </div>
</section>

  

 





      {/* <section id="bi-cta" className="bi-cta text-center py-5">
    <h3>Ready to Transform Your Business with BI?</h3>
    <p>Contact us today to learn how Business Intelligence can unlock your company's potential.</p>
    <a href="#contact" className="btn btn-success mt-3">Get Started</a>
  </section> */}


  


      <section id="serv_h" className="p_3">
  <div className="container-xl">
    <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4" style={{ backgroundColor: "#343a40", color: "white" }}>
      <div className="col-md-8">
        <div className="serv_h3l">
          <h2 className="text-white">Ready to Build the Next Big Software Solution?</h2>
          <p className="text-white mt-3">Let’s discuss how custom software development can elevate your business and streamline operations.</p>
          <button className="banner-button mt-3">
  <Link to="/contact" className="text-decoration-none text-white">
    Let’s talk <span className="arrow">→</span>
  </Link>
</button>
        </div>
      </div>
      <div className="col-md-4">
        <div className="serv_h3r">
          <div className="grid clearfix">
            <figure className="effect-jazz mb-0">
              <Link to="/contact">
                <img
                  src="./assets/img/2007.png"
                  className="w-100"
                  alt="Software Development"
                />
              </Link>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



    </div>
  );
};

export default SoftwareDevelopment;
